import { AdsChunkSize } from './AdsWithInfiniteScroll.types';
import { GetAdSearchResponse } from '@/api/types/ads.types';
import { padAdsToChunkSize } from '@/utils/helpers';

export const normalizeAdSearchChunk = (
  data: GetAdSearchResponse | undefined,
  chunkSize: AdsChunkSize,
  updateQuery: (
    updateFn: (previousQueryResult: GetAdSearchResponse) => GetAdSearchResponse
  ) => void
) => {
  const nodes = data?.adSearch?.ads?.nodes;
  if (nodes && nodes.length < chunkSize) {
    updateQuery(() => ({
      ...data,
      adSearch: {
        ...data.adSearch,
        ads: {
          ...data.adSearch.ads,
          nodes: padAdsToChunkSize(nodes, chunkSize),
        },
      },
    }));
  }
};
